import { store } from '@/store';
import { ConditionPickerOption } from '@/shared/components/conditions/models/conditions';
import { useConditions } from '@shared/composables/useConditions';

export function useRuleConditions(contextualConditions: ConditionPickerOption[]) {
  return useConditions(store.getters.contactAttributes, undefined, contextualConditions);
}
